module.exports = __webpack_public_path__ + "static/img/RAOS_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAOS_1.png
// module id = DDg1
// module chunks = 0